/** @file The names an argument field offers: images, bones (no generated socket bones) or attachments. */
import type { Doc } from '@pose2d/format/types';
import type { ArgField, ArgKind } from './autorigTypes';

const byName = (names: Iterable<string>): string[] => [...names].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
const none = (): string[] => [];
const images = (doc: Doc): string[] => byName(Object.values(doc.images).map((i) => i.name));
const userBones = (doc: Doc): string[] => byName(Object.values(doc.bones).filter((b) => b.kind === undefined).map((b) => b.name));
const attachments = (doc: Doc, field: ArgField): string[] =>
  byName(Object.values(doc.attachments).filter((a) => field.filter === undefined || field.filter === 'any' || a.type === field.filter).map((a) => a.name));

/** One handler per kind (exhaustive): `limbs` picks from the bones; the free-form and enum kinds have no list. */
const OPTIONS: Record<ArgKind, (doc: Doc, field: ArgField) => string[]> = {
  images, attachment: attachments, bone: userBones, bones: userBones, limbs: userBones,
  facing: none, walkFacing: none, method: none, detail: none, pairs: none, text: none, int: none,
};

/** Sorted names for the picker of `field`; an empty list for kinds without a picker. */
export function argOptions(doc: Doc, field: ArgField): string[] {
  return OPTIONS[field.kind](doc, field);
}
